<!-- Vehicle Info popup -->
<div bsModal #editVehicleInfoModalRef="bs-modal" [config]="modalConfig" class="modal fade" id="editVehicleInfoModal" tabindex="-1" role="dialog" (onShown)="onModalShown()">
  <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
    <div class="modal-content" >
      <div class="modal-header">
        <h5 class="modal-title">Vehicle Info</h5>
        <button type="button" class="close" aria-label="Close"
          (click)="onCancelVehicleInfo(); closeModal()">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body py-3">
        <div>
          <app-call-script [section]="section"></app-call-script>
        </div>
        <form [formGroup]="VehicleInfoForm">
          <div class="row mx-0 mt-3">
            <div class="col-md-6 ">
              <label for="">Vehicle License # / Title
                <span isMandatory [fieldName]="'VehicleLicenceNumber'" [RequiredList]="vehicleReqList"
                class="required">*</span>
              </label>
              <input class="form-control" type="text" name="vehicleNo" maxlength="25" (blur)="licenceNumberCheck($event.target.value)"
                formControlName="VehicleLicenceNumber"
                appHighlightCallScriptFields
                [fieldName]="'VehicleLicenceNumber'" [linkedFieldsList]="vehicleInfoCallScriptFields">
                @if (VehicleInfoForm.get('VehicleLicenceNumber').errors  && (VehicleInfoForm.get('VehicleLicenceNumber').dirty ||
                  VehicleInfoForm.get('VehicleLicenceNumber').touched)) {
                  <div class="alert alert-danger">
                    @if (VehicleInfoForm.get('VehicleLicenceNumber').errors.required) {
                      <span isMandatory [fieldName]="'VehicleLicenceNumber'" [RequiredList]="vehicleReqList"
                        >License
                      is required</span>
                    }
                  </div>
                }
              </div>
              <div class="col-md-6 pt-3 pt-lg-0">
                <label for="">Sticker # / Registration
                  <span isMandatory [fieldName]="'StickerNumber'" [RequiredList]="vehicleReqList"
                  class="required">*</span>
                </label>
                <input class="form-control" type="text" name="stickerNo" maxlength="25"
                  formControlName="StickerNumber"
                  appHighlightCallScriptFields [fieldName]="'StickerNumber'" [linkedFieldsList]="vehicleInfoCallScriptFields">
                  @if (VehicleInfoForm.get('StickerNumber').errors  && (VehicleInfoForm.get('StickerNumber').dirty ||
                    VehicleInfoForm.get('StickerNumber').touched)) {
                    <div class="alert alert-danger">
                      @if (VehicleInfoForm.get('StickerNumber').errors.required) {
                        <span isMandatory [fieldName]="'StickerNumber'" [RequiredList]="vehicleReqList"
                          >Sticker
                          Number
                        is required</span>
                      }
                    </div>
                  }
                </div>
              </div>
              <div class="row mx-0 mt-3">
                <div class="col-md-6">
                  <label for="">Vehicle Make
                    <span isMandatory [fieldName]="'VehicleMake'" [RequiredList]="vehicleReqList"
                    class="required">*</span>
                  </label>
                  <input type="text" class="form-control" formControlName="VehicleMake" maxlength="100"
                    appHighlightCallScriptFields [fieldName]="'VehicleMake'" [linkedFieldsList]="vehicleInfoCallScriptFields">
                    @if (VehicleInfoForm.get('VehicleMake').errors  && (VehicleInfoForm.get('VehicleMake').dirty ||
                      VehicleInfoForm.get('VehicleMake').touched)) {
                      <div class="alert alert-danger">
                        @if (VehicleInfoForm.get('VehicleMake').errors.required) {
                          <span isMandatory [fieldName]="'VehicleMake'" [RequiredList]="vehicleReqList"
                            >Vehicle Make
                          is required</span>
                        }
                      </div>
                    }
                  </div>
                  <div class="col-md-6 pt-3 pt-lg-0">
                    <label for="">Vehicle Model
                      <span isMandatory [fieldName]="'VehicleModel'" [RequiredList]="vehicleReqList"
                      class="required">*</span>
                    </label>
                    <input type="text" class="form-control" formControlName="VehicleModel" maxlength="100"
                      appHighlightCallScriptFields [fieldName]="'VehicleModel'" [linkedFieldsList]="vehicleInfoCallScriptFields">
                      @if (VehicleInfoForm.get('VehicleModel').errors  && (VehicleInfoForm.get('VehicleModel').dirty ||
                        VehicleInfoForm.get('VehicleModel').touched)) {
                        <div class="alert alert-danger">
                          @if (VehicleInfoForm.get('VehicleModel').errors.required) {
                            <span isMandatory [fieldName]="'VehicleModel'" [RequiredList]="vehicleReqList"
                              >Vehicle Model
                            is required</span>
                          }
                        </div>
                      }
                    </div>
                  </div>
                  <div class="row mx-0 mt-3">
                    <div class="col-md-6">
                      <label for="">Vehicle Color
                        <span isMandatory [fieldName]="'VehicleColor'" [RequiredList]="vehicleReqList"
                        class="required">*</span>
                      </label>
                      <input type="text" class="form-control" formControlName="VehicleColor" maxlength="50"
                        appHighlightCallScriptFields [fieldName]="'VehicleColor'" [linkedFieldsList]="vehicleInfoCallScriptFields">
                        @if (VehicleInfoForm.get('VehicleColor').errors  && (VehicleInfoForm.get('VehicleColor').dirty ||
                          VehicleInfoForm.get('VehicleColor').touched)) {
                          <div class="alert alert-danger">
                            @if (VehicleInfoForm.get('VehicleColor').errors.required) {
                              <span isMandatory [fieldName]="'VehicleColor'" [RequiredList]="vehicleReqList"
                                >Vehicle Color
                              is required</span>
                            }
                          </div>
                        }
                      </div>
                      <div class="col-md-6 pt-3 pt-lg-0">
                        <label for="">Vehicle Year
                          <span isMandatory [fieldName]="'VehicleYear'" [RequiredList]="vehicleReqList"
                          class="required">*</span>
                        </label>
                        <ejs-datepicker class="form-control p-0 h-auto" (change)="onYearChange($event.value)"
                          formControlName="VehicleYear" [allowEdit]="false" id="vehicleyrm" format='yyyy'
                          start='Decade' depth='Decade' [showTodayButton]="false" [max]="maxyear"
                          appHighlightCallScriptFields [fieldName]="'VehicleYear'"
                        [linkedFieldsList]="vehicleInfoCallScriptFields"></ejs-datepicker>
                        @if (VehicleInfoForm.get('VehicleYear').errors  && (VehicleInfoForm.get('VehicleYear').dirty ||
                          VehicleInfoForm.get('VehicleYear').touched)) {
                          <div class="alert alert-danger">
                            @if (VehicleInfoForm.get('VehicleYear').errors.required) {
                              <span isMandatory [fieldName]="'VehicleYear'" [RequiredList]="vehicleReqList"
                                >Vehicle Year
                              is required</span>
                            }
                          </div>
                        }
                      </div>
                    </div>
                    <div class="row mx-0 mt-3">
                      <div class="col-md-6">
                        <label for="">Vehicle Vin
                          <span isMandatory [fieldName]="'VehicleVin'" [RequiredList]="vehicleReqList"
                          class="required">*</span>
                        </label>
                        <input type="text" class="form-control" formControlName="VehicleVin" maxlength="100"
                          (keypress)="onKeyPress($event)"   (paste)="onPaste($event)"
                          appHighlightCallScriptFields [fieldName]="'VehicleVin'" [linkedFieldsList]="vehicleInfoCallScriptFields">
                          @if (VehicleInfoForm.get('VehicleVin').errors  && (VehicleInfoForm.get('VehicleVin').dirty ||
                            VehicleInfoForm.get('VehicleVin').touched)) {
                            <div class="alert alert-danger">
                              @if (VehicleInfoForm.get('VehicleVin').errors.required) {
                                <span isMandatory [fieldName]="'VehicleVin'" [RequiredList]="vehicleReqList"
                                  >VehicleVin is
                                required</span>
                              }
                            </div>
                          }
                        </div>
                        <div class="col-md-6 pt-3 pt-lg-0">
                          <label for="">Vehicle Length
                            <span class="required" isMandatory [fieldName]="'VehicleLength'"
                            [RequiredList]="vehicleReqList">*</span>
                          </label>
                          <input type="text" class="form-control" formControlName="VehicleLength"
                            [appTwoDigitDecimal]='dimensionDirectiveSetting'
                            appHighlightCallScriptFields [fieldName]="'VehicleLength'"
                            [linkedFieldsList]="vehicleInfoCallScriptFields">
                            @if (VehicleInfoForm.get('VehicleLength').errors  && (VehicleInfoForm.get('VehicleVin').dirty ||
                              VehicleInfoForm.get('VehicleLength').touched)) {
                              <div class="alert alert-danger">
                                @if (VehicleInfoForm.get('VehicleLength').errors.required) {
                                  <span isMandatory [fieldName]="'VehicleLength'" [RequiredList]="vehicleReqList"
                                    >Vehicle
                                    Length is
                                  required</span>
                                }
                              </div>
                            }
                          </div>
                        </div>
                        <div class="row mx-0 mt-3">
                          <div class="col-md-6">
                            <label for="">Vehicle State
                              @if (!emptyStateList) {
                                <span isMandatory [fieldName]="'VehicleState'" class="required"
                                [RequiredList]="vehicleReqList">*</span>
                              }
                            </label>
                            <select class="form-select w-100" id="State" formControlName="VehicleState"
                              appHighlightCallScriptFields
                              [fieldName]="'VehicleState'" [linkedFieldsList]="vehicleInfoCallScriptFields">
                              @if (!emptyStateList) {
                                <option value="" selected>Select</option>
                              }
                              @if (emptyStateList) {
                                <option value="0">--</option>
                              }
                              @for (item of statesList; track item) {
                                <option [value]="item.Id">{{item.Name}}</option>
                              }
                            </select>

                            @if (VehicleInfoForm.get('VehicleState').errors  && (VehicleInfoForm.get('VehicleState').dirty || VehicleInfoForm.get('VehicleState').touched)) {
                              <div class="alert alert-danger "
                                >
                                @if (VehicleInfoForm.get('VehicleState').required || (VehicleInfoForm.get('VehicleState').value === '' || null)) {
                                  <span
                                    >Vehicle
                                  State is required</span>
                                }
                              </div>
                            }
                          </div>
                        </div>
                        <div class="row mx-0 mt-3">
                          <div class="col-md-6">
                            <label for="">Towing Company Name
                              <span isMandatory [fieldName]="'TowingCompanyName'" [RequiredList]="vehicleReqList"
                              class="required">*</span>
                            </label>
                            <input class="form-control" type="text" maxlength="50"
                              formControlName="TowingCompanyName"
                              appHighlightCallScriptFields
                              [fieldName]="'TowingCompanyName'" [linkedFieldsList]="vehicleInfoCallScriptFields">
                              @if (VehicleInfoForm.get('TowingCompanyName').errors  && (VehicleInfoForm.get('TowingCompanyName').dirty ||
                                VehicleInfoForm.get('TowingCompanyName').touched)) {
                                <div class="alert alert-danger">
                                  @if (VehicleInfoForm.get('TowingCompanyName').errors.required) {
                                    <span isMandatory [fieldName]="'TowingCompanyName'" [RequiredList]="vehicleReqList"
                                      >Towing Company Name
                                    is required</span>
                                  }
                                </div>
                              }
                            </div>
                            <div class="col-md-6 pt-3 pt-lg-0">
                              <label for="">Towing Company Phone Number
                                <span isMandatory [fieldName]="'TowingCompanyPhone'" [RequiredList]="vehicleReqList"
                                class="required">*</span>
                              </label>
                              <ejs-maskedtextbox #towingphone [mask]="PhoneNumberMask" name="phone" id="TowingCompanyPhone"
                                formControlName="TowingCompanyPhone" cssClass="form-control p-0" (focus)="onStartfocus($event)"
                                (created)="onCreated($event, towingphoneInstance)"
                                (change)="onValueChange($event, towingphoneInstance)"
                                appHighlightCallScriptFields
                                [fieldName]="'TowingCompanyPhone'" [linkedFieldsList]="vehicleInfoCallScriptFields" >
                              </ejs-maskedtextbox>
                              @if (VehicleInfoForm.get('TowingCompanyPhone').errors  && (VehicleInfoForm.get('TowingCompanyPhone').dirty ||
                                VehicleInfoForm.get('TowingCompanyPhone').touched)) {
                                <div class="alert alert-danger">
                                  @if (VehicleInfoForm.get('TowingCompanyPhone').errors.required) {
                                    <span isMandatory [fieldName]="'TowingCompanyPhone'" [RequiredList]="vehicleReqList"
                                      >Towing Company Phone Number
                                      is required
                                    </span>
                                  }
                                  @if (VehicleInfoForm.get('TowingCompanyPhone').errors &&
                                    VehicleInfoForm.get('TowingCompanyPhone').errors.lessThanTen) {
                                    <div>
                                      <span>Enter 10 digit Towing Company Phone Number</span>
                                    </div>
                                  }
                                </div>
                              }
                            </div>
                          </div>
                          <div class="row mx-0 mt-3">
                            <div class="col-md-12">
                              <label for="">Towing Company Address
                                <span isMandatory [fieldName]="'TowingCompanyAddress'" [RequiredList]="vehicleReqList"
                                class="required">*</span>
                              </label>
                              <input class="form-control" type="text" maxlength="150" formControlName="TowingCompanyAddress"
                                appHighlightCallScriptFields [fieldName]="'TowingCompanyAddress'" [linkedFieldsList]="vehicleInfoCallScriptFields">
                                @if (VehicleInfoForm.get('TowingCompanyAddress').errors  && (VehicleInfoForm.get('TowingCompanyAddress').dirty ||
                                  VehicleInfoForm.get('TowingCompanyAddress').touched)) {
                                  <div class="alert alert-danger">
                                    @if (VehicleInfoForm.get('TowingCompanyAddress').errors.required) {
                                      <span isMandatory [fieldName]="'TowingCompanyAddress'" [RequiredList]="vehicleReqList"
                                        >Towing Company Address
                                      is required</span>
                                    }
                                  </div>
                                }
                              </div>
                            </div>
                          </form>
                        </div>

                        <div class="modal-footer">
                          <button type="button" class="btn btn-outline-primary me-3"
                          (click)="onCancelVehicleInfo(); closeModal()">Cancel</button>
                          <button type="button" class="btn btn-primary" [disabled]="disableSave()"
                          (click)="onSaveVehicleInfo(); closeModal()">Save</button>
                        </div>
                      </div>
                    </div>
                  </div>












